<script setup>
</script>

<template>
  <section class="section">
    <div class="wrap" style="display:grid; gap: var(--sp-6); max-width: 860px;">
      <h1>Wat is Reiki?</h1>

      <div>
        <p>
          Als je op internet gaat zoeken over "Wat is Reiki" ontdek je dat er gigantisch veel
          erover is gezegd, geschreven, gezongen, verfilmd. Zodanig veel dat je door de bomen het
          bos niet meer gaat vinden. Ik vertel je in dit stuk hoe IK het zie en iemand anders zal
          vast een ander idee hebben. Hopelijk heb jij nadat je bij mij op de tafel hebt gelegen of
          een inwijding hebt gehad zelf een idee, een mening wat Reiki is. Tot die tijd dit stuk van mij.
        </p>
        <p>
          Laten we beginnen met het woord Reiki. Het komt uit het Japans en het bestaat uit 2 woorden
          Rei en Ki. Rei betekent Universeel. Ki betekent levensenergie. Universele Levensenergie.
          Maar wat wordt daarmee bedoeld? Want over deze woorden kan je ook, naargelang je religieuze
          traditie en/of je filosofische school over discussiëren. Wat dus sommigen in de Reiki-wereld
          dus ook doen. Mijn duit in dat zakje is deze.
        </p>
        <p>Ik begin met mijn levensovertuiging/religie/filosofie/etc is deze: 1=ALL=❤️</p>
        <p class="equation">
          Ook wel: Getal(=Wiskunde = Logica = Hoofd) = Woord ( = Taal = Gevoel = Lichaam ) =
          Onvoorwaardelijke Liefde ( = Het goddelijke, het zuiverste, het hoogste, het ondeelbare).
        </p>
        <p>
          Ik zeg er dan bij. Met alle consequenties (= gevolgen en oorzaken) die erbij horen. Wij
          Allen zijn 1 en wij Allen zijn Liefde. En die LIEFDE van en voor Allen maakt ons 1.
        </p>
        <p>
          EN… We LEVEN in een duale wereld, maar WE ZIJN DAT NIET. (= hence wat al die "guru's"
          zeggen dat alles een illusie is… Duh…) We zijn hier om DAT te herinneren en om DAT
          daadwerkelijk uit te beelden in ons leven
        </p>
        <p>
          Reiki is die energie, die bron die ons, wezens in dit multi-versum, maakt en die ons
          verbindt. Reiki is die energie die IS, die WAS en die ZAL ZIJN.
        </p>
        <p>
          Deze Universele Energie kan je oproepen voor jezelf je eigen "genezing" EN om jou te
          gebruiken als doorgeefluik om andere wezens TE ONDERSTEUNEN in hun eigen
          "("genezings" / "Herinnerings") processen".
        </p>
        <p>
          Okay… Zal je nu misschien zeggen. En waarom zijn er zoveel SOORTEN Reiki? Omdat de
          verschillende wezens allemaal hun eigen wegen, hun eigen aanpak, etc. hebben. Maar al deze
          wegen verwijzen mijns inziens steeds naar hetzelfde. Namelijk 1=ALL=❤️.
        </p>
        <p>
          Voor mij zijn het gereedschappen in een gereedschapskist. Dan pak ik de Engelse sleutel
          (Reiki Seichem) of de gewone knijptang (Reiki Usui). Afhankelijk van het proces en het wezen.
        </p>
      </div>

      <aside class="soft-note">
        <p>
          <strong>Let op!</strong> Door het ontvangen van een Reiki-behandeling kan je (zelf)
          bewustzijn worden vergroot en verhoogt het de kans op persoonlijke transformatie met
          innerlijke vrede en vreugde ten gevolge.
        </p>
      </aside>

      <div class="page-tail">
        <p class="read-also">
          <span class="k">Lees ook:</span>
          <router-link to="/elementen-healing" class="jargon-link">Elementen Healing van Avelon</router-link> ·
          <router-link to="/wat-is-leela" class="jargon-link">Leela</router-link>
        </p>
        <div class="actions">
          <router-link class="btn btn-primary" to="/contact-2">Vrijblijvend kennismaken</router-link>
          <router-link class="btn btn-ghost" to="/spirituele-coaching">Naar spirituele coaching</router-link>
        </div>
      </div>
    </div>
  </section>
</template>
